export default class TaskModel {
    TaskId: number;
    Title: string;
    ClientId:number;
    ClientName:string;
    ClientCompanyId: number;
    ClientCompanyName:string;
    AssignedToUserId:number;
    PriorityId:number;
    Priority:string;  
    StatusId:number;
    Stauts:number;
    UserId:number;
    AssignedTo: string;
    Description: string;
    SelectedCompanies: any;
}

export const PriorityOptions =  [
    { value: '1', label: 'Critical', name:'Priority' },
    { value: '2', label: 'High', name:'Priority' },
    { value: '3', label: 'Medium', name:'Priority' },
    { value: '4', label: 'Low', name:'Priority' },
    { value: '5', label: 'Planning', name:'Priority' }
];